export type AuditRelatedParamDefinitions = {
  categoryId: string;
  paramDefinitionId: string;
};
